import { useState } from "react";
import { backStepByPath } from "../../../utils/updateStepBack";
import { useLocation } from "react-router-dom";
import { useStepNavigation } from "ah_utility/NavigationEngine";
var useUI = function (STEP, navigate) {
    var _a = useState({
        show: false,
        message: "",
        type: "success",
    }), seeToast = _a[0], setSeeToast = _a[1];
    var pathname = useLocation().pathname;
    var dataNavigation = useStepNavigation({ currentStepId: pathname }).navigation;
    var handleBack = function () {
        backStepByPath(pathname);
        navigate("".concat(dataNavigation === null || dataNavigation === void 0 ? void 0 : dataNavigation.back));
    };
    var showToast1 = function (show, title, type) {
        setSeeToast({
            show: show,
            message: title,
            type: type,
        });
    };
    return {
        seeToast: seeToast,
        handleBack: handleBack,
        showToast1: showToast1,
    };
};
export default useUI;
